import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';

export const LoginPage = () => {
  const { login, loading } = useAuth();

  return (
    <div className="login-container" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/goa-resort-bg.jpg)` }}>
      <div className="login-card">
        <div className="login-header">
          <h1>🌴 Goa Resort Investment</h1>
          <p className="login-tagline">Five-Family Co-Investment Briefing</p>
        </div>

        <div className="login-content">
          <p className="login-subtitle">
            Sign in to access the investment briefing materials.
          </p>

          <button
            className="btn btn-primary btn-large"
            onClick={login}
            disabled={loading}
          >
            {loading ? 'Redirecting...' : 'Sign In →'}
          </button>

          <p className="login-hint">
            Use your email and password, or request a one-time code.
          </p>
        </div>

        <div className="login-footer">
          <p className="security-note">
            🔒 This platform contains confidential investment materials.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
